import orderBy from 'lodash/orderBy';
import { useRouter } from 'next/router';
import { useState, useEffect } from 'react';

import BANNER_SORT_OPTIONS from '../../utils/bannerOptions';

import OfferTile from './OfferTile';
import ProductListItem from './ProductListItem';
import styles from './ProductMenu.module.scss';

export default function OfferList({ offers, waveSpecialProductsGrouped = [], showBySelection }) {
  const [offersShown, setOffersShown] = useState([]);
  const router = useRouter();
  useEffect(() => {
    getFilteredProducts();
  }, [showBySelection, offers, router.query]);

  if (!offers.length && !waveSpecialProductsGrouped.length) return null;

  function getSortedOffers() {
    if (showBySelection === BANNER_SORT_OPTIONS.catalog) {
      return offers;
    }
    if (showBySelection === BANNER_SORT_OPTIONS.expensive) {
      return orderBy(offers, 'price', 'desc');
    }
    if (showBySelection === BANNER_SORT_OPTIONS.cheap) {
      return orderBy(offers, 'price', 'asc');
    }
    if (showBySelection === BANNER_SORT_OPTIONS.alphabetical) {
      return orderBy(offers, 'name', 'asc');
    }
  }

  function getFilteredProducts() {
    const offersByBannerOptions = getSortedOffers();
    setOffersShown(offersByBannerOptions);
  }
  return (
    ((offersShown && offersShown.length !== 0) ||
      (waveSpecialProductsGrouped && waveSpecialProductsGrouped.length !== 0)) && (
      <>
        <div className={styles.listHeader}>
          <p className={styles.listTitle}>Σας συμφέρει</p>
        </div>
        <div className={styles.bannerContainer}>
          {waveSpecialProductsGrouped.length !== 0 && (
            <>
              {waveSpecialProductsGrouped.map((p, index) => (
                <ProductListItem
                  key={p._id}
                  _product={p}
                  itemListId="Offers"
                  itemListName="Προσφορές"
                  positionInList={index + 1}
                />
              ))}
            </>
          )}
          {offersShown.map(o => (
            <OfferTile key={o._id} offer={o} />
          ))}
        </div>
      </>
    )
  );
}
